/**
 * Formats a date to a human-readable string
 */
export function formatDate(date) {
    const d = new Date(date);
    return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
/**
 * Formats a number to include comma separators
 */
export function formatNumber(num) {
    return new Intl.NumberFormat().format(num);
}
/**
 * Truncates a string to a maximum length with ellipsis
 */
export function truncateString(str, maxLength) {
    if (str.length <= maxLength)
        return str;
    return `${str.slice(0, maxLength)}...`;
}
/**
 * Formats a file size in bytes to a human-readable string
 */
export function formatFileSize(bytes) {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let size = bytes;
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`;
}
//# sourceMappingURL=format.js.map